(function () {
'use strict';

// copy-paste and freeze from https://github.yandex-team.ru/RUM/rum-counter/blob/master/src/bundle/send.js
(function(rum) {
    /**
     * @file
     * Отправка запроса со счетчиками
     */
    var MAX_BATCH_COUNTERS = 42; // определено в Кликдемоне
    var COUNTERS_BATCH_TIMEOUT = 15; // интервал в миллисекундах, в течение которого счётчики склеиваются

    rum.countersBatchData = [];
    rum.counterTimerId;

    /**
     * Отправка счётчика. Основной транспорт - sendBeacon, запасной - XMLHttpRequest. Быстро поступающие одиночные события
     * накапливаются и отправляются пачками по MAX_BATCH_COUNTERS штук.
     *
     * Количество и порядок параметров соответствует счётчику СЕРПа
     * window.wbt = function(link, path, vars, clck, tree, sts, counterParams)
     *
     * @param {*} link - не используется
     * @param {String} path
     * @param {String} vars
     * @param {*} clck - не используется
     * @param {*} tree - не используется
     * @param {*} sts - не используется
     * @param {Array} counterParams
     */
    rum.send = function(link, path, vars, clck, tree, sts, counterParams) {
        clearTimeout(rum.counterTimerId);

        var counterSections = getCounterSections(link, path, vars, tree, sts, counterParams);
        // reqid добавляется на случай попадания в батч счётчиков из разных запросов –
        // например, после аякса
        rum.countersBatchData.push('/reqid=' + rum.getSetting('reqid') + counterSections.join(''));

        if (rum.countersBatchData.length < MAX_BATCH_COUNTERS) {
            rum.counterTimerId = setTimeout(sendBatchRequest, COUNTERS_BATCH_TIMEOUT);
        } else {
            sendBatchRequest();
        }
    };

    function sendBatchRequest() {
        var clck = rum.getSetting('clck'),
            data = rum.countersBatchData.join('\r\n');

        rum.countersBatchData = [];
        rum.counterTimerId = null;

        if (!clck) {
            return;
        }

        var sendBeaconPostAvailable = navigator.sendBeacon && rum.getSetting('beacon'),
            sendBeaconResult = sendBeaconPostAvailable && navigator.sendBeacon(clck, data);

        if (!sendBeaconResult) {
            // Использование XMLHttpRequest делает невозможным отправку ошибок из
            // worker-скриптов. И вообще, пора уже везде использовать fetch,
            // если это возможно.
            if (typeof self !== 'undefined' && self.fetch) {
                fetch(clck, {
                    method: 'POST',
                    body: data
                })
                    // Без обработки catch логгер начинает логировать сам себя Unhandled rejection: Failed to fetch
                    .catch(function() {
                        // noop
                    });
            } else {
                var xhr = new XMLHttpRequest();
                xhr.open('POST', clck);
                xhr.send(data);
            }
        }
    }

    // Используются только параметры path vars counterParams
    function getCounterSections(link, path, vars, tree, sts, counterParams) {
        var slots = rum.getSetting('slots');
        return [
            counterParams ? '/' + counterParams.join('/') : '',
            '/path=' + path,
            slots ? '/slots=' + slots.join(';') : '',
            vars ? '/vars=' + vars : '',
            '/cts=' + new Date().getTime(),
            '/*'
        ];
    }
})(Ya.Rum);

}());
